import "../index";

import { getAuth, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc, getFirestore } from "firebase/firestore";

const auth = getAuth();
const db = getFirestore();
var alertInfo = document.querySelector("#alert");
var alertResetInfo = document.querySelector("#reset-alert");
var loginButton = document.querySelector("#login-button");

document.querySelector("#form-signin").addEventListener("submit", (e) => {
    e.preventDefault();

    alertInfo.innerHTML = "";
    loginButton.innerHTML = `<div class="spinner-border text-light spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>`
    loginButton.disabled = true;

    var email = document.getElementById("inputEmail").value.trim();
    var password = document.getElementById("inputPassword").value;

    signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
            const user = userCredential.user;

            // Check if user had verified the email, and whether they had filled their info

            if (user.emailVerified) {
                dataCheck(user.uid).then((userHaveInfo) => {
                    resetSpinner();
                    if (userHaveInfo) {
                        window.location.href = "/dashboard.html";
                    } else {
                        judgeCheck(user.uid).then((isJudge) => {
                            if (isJudge) window.location.href = "/judge/dashboard.html";
                            else setAlert("You had signed up for an account but you haven't filled out the registration form! Unfortunately the registration period had ended. See you next time!");
                        }).catch(error => {
                            setAlert(`${error.message} (Please contact admin@vhackusm.com)`);
                        });
                    }
                }).catch((error) => {
                    setAlert(`${error.message} (Please contact admin@vhackusm.com)`);
                })
            } else {
                setAlert("You had signed up for an account but you haven't verified your email and filled out the registration form! Unfortunately the registration period had ended. See you next time!");
                resetSpinner();
            }
        })
        .catch((error) => {
            const errorCode = error.code;

            switch (errorCode) {
                case "auth/invalid-email":
                    setAlert("Invalid email!");
                    break;
                case "auth/user-disabled":
                    setAlert("Your account is disabled, it might be because you are not eligible for the hackathon or other reason. Check your email inbox for any notification.");
                    break;
                case "auth/user-not-found":
                case "auth/wrong-password":
                    setAlert("Wrong email or password!");
                    break;
                case "auth/too-many-requests":
                    setAlert("Your account is temporarily disabled due to multiple failed sign in attempts. You can reset your password to restore access or try again later.");
                    break;
                default:
                    setAlert(`${error.message}`);
                    break;
            }
            resetSpinner();
        });
});


document.querySelector("#reset-button").addEventListener("click", (e) => {
    e.preventDefault();
    const button = document.querySelector("#reset-button");
    button.innerHTML = `<div class="spinner-border text-light spinner-border-sm" role="status"><span class="visually-hidden">Loading...</span></div>`;
    button.disabled = true;
    
    var email = document.querySelector("#inputEmailReset");

    sendPasswordResetEmail(auth, email.value)
        .then(() => {
            button.innerHTML = `Reset password`;
            button.disabled = false;
            setAlertReset();
        })
        .catch((error) => {
            button.innerHTML = `Reset password`;
            button.disabled = false;
            setAlertReset();
        });
}, false);

function resetSpinner() {
    loginButton.disabled = false;
    loginButton.innerHTML = "Sign in";
}

async function dataCheck(uid) {
    const docRef = doc(db, "users", uid);
    const docSnap = await getDoc(docRef);
    return docSnap.exists();
}

async function judgeCheck(uid) {
    const docRef = doc(db, "judges", uid);
    const docSnap = await getDoc(docRef);
    return docSnap.exists();
}

function setAlert(msg) {
    alertInfo.innerHTML = `<div class="alert alert-warning" role="alert">${msg}</div>`;
}

function setAlertReset() {
    alertResetInfo.innerHTML = `<div class="alert alert-primary" role="alert">A reset password email is sent your way if the account exists.</div>`;
}
